<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Report</h1>

    <portal to="quickActions" >
      <div>
        <inertia-link :href="route('admin.reports.product-search-terms')" class="border px-2 py-1 bg-white rounded">Product Search Terms</inertia-link>
      </div>
    </portal>

    <div>
      <product-order-qty-report/>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Admin/Layout'
import ProductOrderQtyReport from './ProductOrderQtyReport'

export default {
  metaInfo: { title: 'Reports' },
  components: {
    ProductOrderQtyReport
  },
  layout: Layout,
}
</script>
